// src/hooks/AuthProvider.jsx
import { createContext, useContext, useState } from "react";
import API_BASE_URL from "../config";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || null);
    const [token, setToken] = useState(JSON.parse(localStorage.getItem("token")) || "");


    const loginAction = async (credentials) => {

        const URL = `/api/gallery/profiles/login`
        try {
            const res = await fetch(URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: credentials,
            });
            const data = await res.json();

            console.log(data);

            if (data.error){
                return {error: data.error};
            }
            if (data.user && data.session) {
                const { user, session } = data;
                setUser(user);
                setToken(session);
                localStorage.setItem("token", JSON.stringify(session));
                localStorage.setItem("user", JSON.stringify(user));

                return { success: true };

            } else {
                return { error: data.error || "Login failed" };
            }
        } catch (err) {
            console.error(err);
        }
    };
    const logOut = () => {
        setUser(null);
        setToken("");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    };
    return (
        <AuthContext.Provider value={{ user, token, loginAction, logOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);